import React from "react";
import Index from "../components/landingPage";

function LandingPage() {
  return (
    <>
        <Index />
    </>
  );
}

export default LandingPage;
